export const getInitHolidayParams = () => {
  return {
    sizePerPage: 10,
    page: 1,
    sort: "-maker_date",
    columnFilter: {},
    columnFilterKeep: {},
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "hub,maker,checker",
    run: false,
  };
};
